import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

export default function (app) {
  app.use(Toast, {
    transition: "Vue-Toastification__fade",
    maxToasts: 3,
    newestOnTop: true,
    filterBeforeCreate: (toast, toasts) => {
      if (toasts.filter(t => t.type === toast.type && t.content === toast.content).length !== 0) {

        return false // Discards the toast
      }
      
      return toast
    },
  })
}
